export const formatPlainText = (value, fallback = '') => {
  const text = String(value || '').replace(/\s+/g, ' ').trim()
  return text || fallback
}

export const formatTitleText = (value, fallback = '') => {
  const text = formatPlainText(value)
  if (!text) return fallback
  return text
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}

export const formatSentenceText = (value, fallback = '') => {
  const text = formatPlainText(value)
  if (!text) return fallback
  return text.charAt(0).toUpperCase() + text.slice(1)
}
